// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","card":"NotFound_card__8jYUZ","icon":"NotFound_icon__JEwDt","link":"NotFound_link__k4nv4","title":"NotFound_title__OQ-MU"};